import type { Match, MatchFormat, SetScore } from '@/data/types';

export function setsToWin(format: MatchFormat): number {
  return { BO3: 2, BO5: 3, BO7: 4 }[format];
}

/** Сводка сетов "X:Y" — проверка по формату. */
export function isValidSummary(s: { a: number; b: number }, format: MatchFormat): boolean {
  const need = setsToWin(format);
  const total = s.a + s.b;
  if (s.a < 0 || s.b < 0) return false;
  if (s.a !== need && s.b !== need) return false;
  if (s.a === need && s.b > need) return false;
  if (s.b === need && s.a > need) return false;
  if (s.a === s.b) return false;
  // Минимум один из них = need, максимум — need*2 - 1 сетов в сумме
  const maxSets = need * 2 - 1;
  return total >= need && total <= maxSets;
}

/** Корректен ли счёт одного сета в настольном теннисе (до 11, с разницей в 2). */
export function isValidSetScore(s: SetScore): boolean {
  if (s.a < 0 || s.b < 0) return false;
  const max = Math.max(s.a, s.b);
  const min = Math.min(s.a, s.b);
  if (max < 11) return false;
  if (max === 11 && min <= 9) return true;
  // 10-10 deuce: победа с разницей в 2
  if (max >= 11 && max - min === 2 && min >= 10) return true;
  return false;
}

/** По массиву сетов вычисляет id победителя или null, если ещё не определён/ошибка. */
export function computeWinnerFromSets(
  sets: SetScore[],
  format: MatchFormat,
  idA: string,
  idB: string
): string | null {
  const need = setsToWin(format);
  let aWins = 0;
  let bWins = 0;
  for (const set of sets) {
    if (!isValidSetScore(set)) return null;
    if (set.a > set.b) aWins++;
    else bWins++;
    if (aWins === need) return idA;
    if (bWins === need) return idB;
  }
  return null;
}

/**
 * Прогресс раунда: "(сыграно/всего)" по списку матчей раунда.
 * Например 2 из 4 сыграно → "(2/4)".
 */
export function roundProgressLabel(roundMatches: Match[]): string {
  const total = roundMatches.length;
  const played = roundMatches.filter((m) => m.status === 'COMPLETED').length;
  return `(${played}/${total})`;
}
